<template>
  <a-card>
    <a-form layout="inline">
      <a-row type="flex" justify="space-between">
        <div>
          <a-form-item label="key">
            <a-input placeholder="请输入key" v-model="search.key" style="width: 260px" :maxLength="20" allowClear />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getPageList(true)">查询</a-button>
          </a-form-item>
        </div>

        <a-form-item>
          <a-button type="primary" @click="showModal()">新增字段</a-button>
        </a-form-item>
      </a-row>
    </a-form>
    <div class="table">
      <a-table
        :columns="columns"
        rowKey="id"
        :loading="loading"
        :dataSource="dataSource"
        :pagination="{
          current: pages.PageIndex,
          pageSize: pages.PageSize,
          total: pages.total,
          showSizeChanger: true,
          showLessItems: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: onPageChange,
          onShowSizeChange: onPageChange,
        }"
      >
        <div slot="action" slot-scope="text, record">
          <a @click="edit(record)" style="margin-right: 8px"> <a-icon type="edit" />编辑 </a>
          <a-popconfirm title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="deleteRecord(record)">
            <a style="color: #f00; margin-right: 8px"> <a-icon type="delete" />删除 </a>
          </a-popconfirm>
        </div>
        <div slot="valueType" slot-scope="text, record">
          <span v-if="record.valueType == 1">字符串</span>
          <span v-if="record.valueType == 2">json</span>
        </div>
      </a-table>
    </div>
    <a-modal v-model="visable" width="600px" title="新增字段" :centered="true" @ok="modleOk" @cancel="cancel">
      <a-form-model ref="ruleForm" :model="modleForm" :rules="modleRules" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="key值" prop="key">
          <a-input v-model="modleForm.key" :maxLength="20" :disabled="!!currentRecord.id" placeholder="请输入key" />
        </a-form-model-item>
        <a-form-model-item label="value类型" prop="valueType">
          <!-- <a-textarea v-model="modleForm.value" rows="4" :maxLength="50" placeholder="请输入value" @blur="formatValue" /> -->
          <a-select v-model="modleForm.valueType" placeholder="请选择值类型" @change="changeType">
            <a-select-option :value="1"> 字符串 </a-select-option>
            <a-select-option :value="2"> json </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="value值" prop="value">
          <a-textarea v-if="modleForm.valueType == 2" v-model="modleForm.value" rows="10" @blur="formatValue" @keydown="handleKeydown"></a-textarea>
          <a-input v-else-if="modleForm.valueType == 1" v-model="modleForm.value" rows="4" placeholder="请输入value" />
          <a-input v-else v-model="modleForm.value" rows="4" placeholder="请输入value" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item ref="remark" label="备注" prop="remark">
          <a-input v-model="modleForm.remark" type="textarea" :maxLength="500" placeholder="请输入备注" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>
<script>
import { ParamsApi } from '@/utils/http'
export default {
  name: 'ParamsSetting',
  data() {
    return {
      columns: [
        {
          title: 'key',
          dataIndex: 'key',
          align: 'center',
        },
        {
          title: 'value',
          dataIndex: 'value',
          align: 'center',
          width: '500px',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          align: 'center',
          width: '400px',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      dataSource: [],
      loading: false,
      search: {},
      pages: {
        total: 0,
        PageIndex: 1,
        PageSize: 10,
      },
      visable: false,
      modleForm: {},
      currentRecord: {},
      modleRules: {
        key: [{ required: true, message: '请填写key值', trigger: 'blur' }],
        value: [
          { required: true, message: '请填写value值', trigger: 'blur' },
          {
            validator: (_, value, cb) => {
              if (this.modleForm.valueType == 2) {
                if (/^(-)?\d+$/.test(value)) {
                  return cb(new Error('JSON 格式不正确'))
                }
                try {
                  JSON.stringify(JSON.parse(value), null, 2)
                  cb()
                } catch (e) {
                  cb(new Error('JSON 格式不正确'))
                }
              } else if (this.modleForm.valueType == 3) {
                if (!/^(-)?\d+$/.test(value)) {
                  return cb(new Error('请输入长整型数值'))
                }
              }
              return cb()
            },
            trigger: 'blur',
          },
        ],
        valueType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        remark: [{ required: true, message: '请填写备注', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.getPageList()
  },
  mounted() {},
  methods: {
    handleKeydown(event) {
      // 检查 Ctrl + C
      if (event.ctrlKey && event.key === 's') {
        this.formatValue()
        event.preventDefault()
      }
    },
    async getPageList(reset) {
      if (reset) {
        this.pages.PageIndex = 1
      }
      const params = {
        pageIndex: this.pages.PageIndex,
        pageSize: this.pages.PageSize,
        ...this.search,
      }
      this.loading = true
      const data = await ParamsApi.getPageList({ ...params }).finally(() => (this.loading = false))
        this.dataSource = data.data.items
        this.pages.total = data.data.totalCount
        this.pages.PageIndex = data.data.pageIndex
    
    },
    complementJson(json) {
      return json.replace(/['"]?(\w+)['"]?\s{0,}(?=:)\s{0,}/g, '"$1"').replace(/(?<=:)\s{0,}['"](\w*)['"]/g, '"$1"')
    },
    formatValue() {
      const json = this.modleForm.value
      this.formatJson(json)
        .then((res) => {
          this.modleForm.value = res
        })
        .catch((e) => {
          console.log(e)
        })
    },
    async formatJson(json) {
      const type = Object.prototype.toString.call(json).slice(8, -1)
      if (type == 'Object') {
        return JSON.stringify(json, null, 2)
      } else if (type == 'String') {
        try {
          const val = JSON.stringify(JSON.parse(json), null, 2)
          return val
        } catch (e) {
          return Promise.reject(e)
        }
      }
    },
    onPageChange(current, size) {
      this.pages.PageIndex = current
      this.pages.PageSize = size
      this.getPageList()
    },
    showModal(record = {}) {
      this.currentRecord = record
      this.visable = true
    },
    modleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const params = {
            ...this.modleForm,
          }
          if (this.currentRecord.id) {
            params.id = this.currentRecord.id
          }
          this.addRecord(params)
        }
      })
    },
    cancel() {
      this.$refs.ruleForm.resetFields()
      this.currentRecord = {}
      this.modleForm = {}
      this.visable = false
    },
    async addRecord(params = {}) {
      const data = await ParamsApi.editRecord(params)
        this.$message.success('操作成功')
        this.getPageList(true)
        this.cancel()
      
    },
    edit(record = {}) {
      record = { ...record }
      if (record.valueType == 2) {
        this.formatJson(record.value)
          .then((res) => {
            this.modleForm = record
            this.modleForm.value = res
          })
          .catch((e) => {
            this.modleForm = record
            console.log(e)
          })
      } else {
        this.modleForm = record
      }
      this.currentRecord = record
      this.visable = true
    },
    async deleteRecord(record) {
      const data = await ParamsApi.deleteRecord([record.id])
        this.$message.success('操作成功')
        this.getPageList(true)
      
    },
    changeType(e) {
      this.$refs.ruleForm.clearValidate()
    },
  },
}
</script>
<style lang="less" scoped>
.table {
  margin-top: 16px;
}
.VueJsonPretty {
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 12px;
  overflow: auto;
  height: 300px;
}
</style>
